export const instrumentationSchema = {
  scenario: [
    {
      name: 'lightboxDialog',
      value: 'LightboxDialog',
      setting: {},
      activity: [
        {
          name: 'promptActivity',
          value: 'PromptActivity',
        },
      ],
    },
  ],
};
